<template>
  <v-snackbar v-model="snackbar" color="primary">
    {{ text }}
    <template #action="{ attrs }">
      <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
        <v-icon>mdi-window-close</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import eventBus from '@/foundations/services/eventBus';

export default {
  name: 'SnackBar',

  data() {
    return {
      snackbar: false,
      text: '',
    };
  },

  mounted() {
    eventBus.$on('snackbar.open', async (text) => {
      this.text = text;
      this.snackbar = true;
    });
  },
};
</script>

<style scoped></style>
